export default "__VITE_ASSET__BiD5El8o__"